import {
  orderFilterValuesLabels,
  orderTypeLocale,
} from '@epicuro-next/constants/features/localization';
import {
  DefaultFilterValue,
  DefaultOrderBookFilters,
  FiltersFieldIds,
} from '@epicuro-next/models/order-book';
import { OrderType } from 'graphql-api/baskets-api-interfaces';

export const defaultAllDisplayName = $localize`:orderBook|Translation for default All display name@@defaultAllDisplayName:All`;
export const defaultAllValue = 'Any';

export const EMPTY_CATEGORY_DISPLAY_VALUE = $localize`:orderBook|Translation for Category filter Empty value@@categoryFilterEmptyValue:(EMPTY)`;

export const ORDER_TYPE_VALUES: DefaultFilterValue[] = [
  {
    value: 'Now',
    displayName: orderTypeLocale[OrderType.Now],
  },
  {
    value: 'Future',
    displayName: orderTypeLocale[OrderType.Future],
  },
];

export const ORDER_STATUS_VALUES: DefaultFilterValue[] = [
  {
    displayName: orderFilterValuesLabels.orderStatusInbound,
    value: 'true',
    // for backwards compatibility as previously BE sent empty string for Inbound
    alternativeValue: '',
  },
  {
    displayName: orderFilterValuesLabels.orderStatusHistory,
    value: 'false',
  },
];

export const NOOS_TYPE_VALUES: DefaultFilterValue[] = [
  {
    value: 'True',
    displayName: orderFilterValuesLabels.noosTypeTrue,
  },
  {
    value: 'False',
    displayName: orderFilterValuesLabels.noosTypeFalse,
  },
];

export const DEFAULT_ORDER_BOOK_FILTERS_VALUES: DefaultOrderBookFilters = {
  [FiltersFieldIds.OrderStatus]: ORDER_STATUS_VALUES,
  [FiltersFieldIds.OrderIncoming]: ORDER_STATUS_VALUES,
  [FiltersFieldIds.OrderType]: ORDER_TYPE_VALUES,
  [FiltersFieldIds.Noos]: NOOS_TYPE_VALUES,
};
